import { State } from 'src/types'
import { webTop, webBottom } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/web'
import { catchFace } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/catchFace'
import { backAroundWeb } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/backAroundWeb'
import { stitch } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/stitch'
import { backOfIndexToLittle } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/backOfIndexToLittle'
import { boomerang } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/boomerang'
import { littleHook } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/littleHook'
import { liningLeather } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/liningLeather'
import { thumbHook } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/thumbHook'
import { laces } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/lace'
import { atomsEngravedOfBackFace, atomsLabel } from 'src/features/atoms/glove/drawer/labels/atoms'
import { fingerGuardDrawer } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/fingerGuardDrawer'
import { edgeDrawer } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/edgeDrawer'
import { backOfThumbDrawer } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/thumbDrawer'
import { wristBeltDrawer } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/back/wristBeltDrawer'
import { liningEmbroidery, thumbEmbroidery, firstMittChildFingerEmbroidery } from 'src/features/atoms/glove/drawer/common/back/embroidery'
import { canvasResetter } from 'src/util/canvas'
import { loopOfRingFinger } from '../../../common/back/loopOfRingFinger'

export const atomsCanvasFirstMittBack = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  if (!state.boomerang) return
  if (!state.thumb) return
  if (!state.underWeb) return
  // リセット
  canvasResetter(ctx)
  // 裏革
  liningLeather(ctx, state.linings.color)
  const isEmbroideryOfLining = state.embroideries.some((x) => x.position.value === 'leatherLiningFirst')
  // 平裏への刺繍
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningFirst'),
      110,
      -65
    )
  }

  const isEmbroideryOfLiningSecond = state.embroideries.some((x) => x.position.value === 'leatherLiningSecond')
  // 平裏への刺繍
  if (isEmbroideryOfLiningSecond) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningSecond'),
      110,
      -25
    )
  }

  if (state.loopOfRingFinger?.value === 'loopOfRingFinger') {
    // ATOMSは、裏平とカラーを合わせる
    loopOfRingFinger(ctx, state.linings.color, state.stitch.color)
  }

  // 捕球面
  catchFace(ctx, state.catchFace.color)
  // ウェブ先端側
  const printLeatherTypeValue = state.printLeatherType?.value
  await webTop(ctx, state.web.color, state.baseModel, printLeatherTypeValue)
  // ウェブ捕球面側
  await webBottom(ctx, state.web2.color, state.baseModel, printLeatherTypeValue)
  // ブーメラン部分
  await boomerang(ctx, state.boomerang.color, printLeatherTypeValue) // 専用のstateを設けて適用
  // 背面＿人差し指-小指
  await backOfIndexToLittle(ctx, state.boomerang.color, printLeatherTypeValue) // 専用のstateを設けて適用
  // 小指への刺繍
  const isEmbroideryOfChild = state.embroideries.some((x) => x.position.value === 'pinkyFingerSideBack')
  if (isEmbroideryOfChild) {
    firstMittChildFingerEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'pinkyFingerSideBack'),
      -100,
      580
    )
  }

  // 背面＿親指_
  await backOfThumbDrawer(ctx, state.thumb.color, state.stitch.color, printLeatherTypeValue)
  // 手首ベルト
  await wristBeltDrawer(ctx, state, printLeatherTypeValue)

  // 小指掛け紐
  littleHook(ctx, state.littleHook.color)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color)
  // 親指への刺繍
  const isEmbroideryOfThumb = state.embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb) {
    thumbEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -220,
      40,
      -20
    )
  }
  // 背面＿ウェブ周り
  await backAroundWeb(ctx, state.underWeb.color, printLeatherTypeValue)
  // ヘリ革
  edgeDrawer(ctx, state)
  // ステッチ
  stitch(ctx, state.stitch.color)
  // 指カバー
  await fingerGuardDrawer(ctx, state.fingerGuardType.value, state.indexCover.color, state.stitch.color, printLeatherTypeValue)

  // 刺繍
  switch (state.baseModel.productNumber) {
    case 'APL-UR003+':
      atomsLabel(ctx, state.atomsLabel.value, 55, 115, -5, 0.9)
      atomsEngravedOfBackFace(ctx, -35, 15, 0)
      break
    default:
      //'AKG-13'
      atomsLabel(ctx, state.atomsLabel.value, -20, 25, 0, 1)
  }
  // 革紐
  laces(ctx, state.lace.color)
}
